export const CHANNELS_COUNT = 45;

export const channelsState = (list: unknown[]) => {
    let channelsDifference = list.length - CHANNELS_COUNT;
    if (channelsDifference < 0) {
        channelsDifference = 0;
    }

    return {
        channelsDifference,
        channelsListRendered: list.slice(0, CHANNELS_COUNT),
    };
};
